export const imports = {
  'docs/custom-style.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-custom-style" */ 'docs/custom-style.mdx'
    ),
  'docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-index" */ 'docs/index.mdx'
    ),
  'docs/apis/resetIdCounter.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-reset-id-counter" */ 'docs/apis/resetIdCounter.mdx'
    ),
  'docs/apis/Tab.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab" */ 'docs/apis/Tab.mdx'
    ),
  'docs/apis/TabContent.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab-content" */ 'docs/apis/TabContent.mdx'
    ),
  'docs/apis/TabGroup.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab-group" */ 'docs/apis/TabGroup.mdx'
    ),
  'docs/apis/TabHeader.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab-header" */ 'docs/apis/TabHeader.mdx'
    ),
  'docs/apis/TabHeaderItem.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab-header-item" */ 'docs/apis/TabHeaderItem.mdx'
    ),
  'docs/apis/TabPanel.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-tab-panel" */ 'docs/apis/TabPanel.mdx'
    ),
  'docs/apis/useTabState.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-apis-use-tab-state" */ 'docs/apis/useTabState.mdx'
    ),
}
